module.exports = __webpack_public_path__ + "img/LOC.4306e590.png";